(function () {
    'use strict';

    realmCommerceApp.filter("splitCamelCase", SplitCamelCase);

    /*@ngInject*/
    function SplitCamelCase() {
        return (input) => {
            return input.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
        };
    }
})();


// WEBPACK FOOTER //
// ./static/js/app/filters/split.camel.case.filter.js